"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import Modal from "react-modal"
import { FaUserPlus, FaUser } from "react-icons/fa"
import "../styles/Donos.css"

Modal.setAppElement("#root")

const Donos = () => {
  const [donos, setDonos] = useState([])
  const [busca, setBusca] = useState("")
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [novoDono, setNovoDono] = useState({
    nomeCompleto: "",
    email: "",
    cpf: "",
    whatsapp: "",
    senha: "",
  })

  useEffect(() => {
    buscarDonos()
  }, [])

  const buscarDonos = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token")
      const response = await axios.get(`https://api.ticketdovaqueiro.com/api/admin/donos`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setDonos(response.data)
      setLoading(false)
    } catch (err) {
      console.error("Erro ao buscar donos:", err)
      setLoading(false)
    }
  }

  const abrirModal = () => setModalIsOpen(true)
  const fecharModal = () => setModalIsOpen(false)

  const handleChange = (e) => {
    setNovoDono({ ...novoDono, [e.target.name]: e.target.value })
  }

  const criarDono = async (e) => {
    e.preventDefault()
    try {
      const token = localStorage.getItem("token")
      await axios.post(`https://api.ticketdovaqueiro.com/api/admin/criar-dono`, novoDono, {
        headers: { Authorization: `Bearer ${token}` },
      })
      alert("Dono cadastrado com sucesso!")
      buscarDonos()
      fecharModal()
      setNovoDono({ nomeCompleto: "", email: "", cpf: "", whatsapp: "", senha: "" })
    } catch (err) {
      console.error("Erro ao criar dono:", err)
      alert("Erro ao cadastrar dono!")
    }
  }

  const donosFiltrados = donos.filter(
    (d) =>
      d.nomeCompleto?.toLowerCase().includes(busca.toLowerCase()) ||
      d.email?.toLowerCase().includes(busca.toLowerCase()),
  )

  return (
    <div className="container-donos">
      <h2>
        <FaUser /> Gerenciamento de Donos de Evento
      </h2>

      <div className="donos-controls">
        <input
          type="text"
          placeholder="Buscar pelo nome ou email..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />
        <button onClick={abrirModal}>
          <FaUserPlus /> Criar Dono
        </button>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Carregando donos de evento...</p>
        </div>
      ) : donosFiltrados.length === 0 ? (
        <div className="empty-state">
          <p>Nenhum dono de evento encontrado.</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="tabela-donos">
            <thead>
              <tr>
                <th>Nome Completo</th>
                <th>Email</th>
                <th>CPF</th>
                <th>WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              {donosFiltrados.map((dono) => (
                <tr key={dono._id}>
                  <td>{dono.nomeCompleto || "N/A"}</td>
                  <td>{dono.email || "N/A"}</td>
                  <td>{dono.cpf || "N/A"}</td>
                  <td>{dono.whatsapp || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={fecharModal}
        contentLabel="Criar Dono"
        className="modal"
        overlayClassName="overlay"
      >
        <h3>Criar Dono de Evento</h3>
        <form onSubmit={criarDono} className="form-modal">
          <input
            type="text"
            name="nomeCompleto"
            placeholder="Nome Completo"
            value={novoDono.nomeCompleto}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={novoDono.email}
            onChange={handleChange}
            required
          />
          <input type="text" name="cpf" placeholder="CPF" value={novoDono.cpf} onChange={handleChange} required />
          <input
            type="text"
            name="whatsapp"
            placeholder="WhatsApp"
            value={novoDono.whatsapp}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="senha"
            placeholder="Senha"
            value={novoDono.senha}
            onChange={handleChange}
            required
          />
          <div className="buttons-modal">
            <button type="submit">Salvar</button>
            <button type="button" onClick={fecharModal}>
              Cancelar
            </button>
          </div>
        </form>
      </Modal>
    </div>
  )
}

export default Donos

